module.exports = "/ui/8636dcce096f9fd8e848439dfb22b003.png";